import { getOusterWasmBytes } from './sdkWebPreload';

let sharedOsfWorker: Worker | null = null;

/**
 * Extract worker creation code from main body so we can mock it for testing
 *
 * https://stackoverflow.com/questions/76386296/web-workers-in-create-react-app-jest-error-cannot-use-import-meta-outside-a
 *
 * @returns osf worker
 */
export const getOSFWorker = (): Worker => {
  if (sharedOsfWorker) {
    return sharedOsfWorker;
  }

  const worker = new Worker(new URL('./worker', import.meta.url));

  const originalTerminate = worker.terminate.bind(worker);
  worker.terminate = () => {
    if (sharedOsfWorker === worker) {
      sharedOsfWorker = null;
    }
    originalTerminate();
  };
  sharedOsfWorker = worker;

  // Preload the worker with sdk wasm
  getOusterWasmBytes()
    .then((bytes) => {
      if (!bytes) return;
      // Keep a copy for future workers (not detaching the original)
      const cloned = bytes.slice(0);
      try {
        // Transfer the cloned buffer to avoid copying
        worker.postMessage({ command: 'init_wasm', wasmBytes: cloned }, [
          cloned,
        ]);
      } catch {
        // Fallback: non-transfer post
        worker.postMessage({ command: 'init_wasm', wasmBytes: cloned });
      }
    })
    .catch((e) => {
      console.error('Failed to preload Ouster SDK Web in OSF worker:', e);
    });

  return worker;
};
